import type { ColorStops } from '@/core/utils';

const MPH = 0.44704;

/** Top of the wind colour ramp, m/s (50 mph); stronger winds share its colour. */
export const WIND_RAMP_MAX = 50 * MPH;

/**
 * Wind speed (m/s) → fill: blue, green, yellow, red, purple from calm to 50 mph. Light tones, so the
 * dark labels keep at least 6:1 contrast all along the ramp.
 */
export const WIND_COLOR_STOPS: ColorStops = [
  [0, [96, 165, 250]],
  [WIND_RAMP_MAX * 0.25, [74, 222, 128]],
  [WIND_RAMP_MAX * 0.5, [250, 204, 21]],
  [WIND_RAMP_MAX * 0.75, [248, 113, 113]],
  [WIND_RAMP_MAX, [192, 132, 252]],
];
